import { NotificationItemView, NotificationModel } from '@aionzdev/modules';
import { Injectable } from '@angular/core';
import { AlertNotification } from './api/notifications-api.service';

@Injectable({ providedIn: 'root' })
export class NotificationsMapperService {
  /** Cotai owns the meaning of backend event codes, including unknown-event fallback. */
  toView(alert: AlertNotification, now = Date.now()): NotificationItemView {
    return {
      id: alert._id,
      title: alert.title,
      description: alert.description,
      icon: this.iconForType(alert.type),
      isUnread: !alert.isOpen,
      timeLabel: this.formatTime(alert.createdAt, now),
    };
  }

  private iconForType(type: string): string {
    switch (type) {
      case 'fatura_gerada': return 'attach_money';
      case 'produtor_oc_faturada': return 'assignment_turned_in';
      case 'proposta_recebida_oc':
      case 'proposta_recebida_grao': return 'exposure_plus_1';
      case 'email': return 'email';
      case 'novo_lote':
      case 'oc_publicada': return 'pin_drop';
      case 'news': return 'newspaper';
      default: return 'notifications';
    }
  }

  private formatTime(rawDate: Date | string | null | undefined, now: number): string {
    if (!rawDate) return '';
    const date = new Date(rawDate);
    if (!Number.isFinite(date.getTime())) return '';
    const elapsed = now - date.getTime();
    if (elapsed < 0) return 'Agora';
    const seconds = Math.max(1, Math.floor(elapsed / 1000));
    if (seconds < 60) return `Há ${seconds} ${seconds === 1 ? 'segundo' : 'segundos'}`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `Há ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `Há ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `Há ${days} ${days === 1 ? 'dia' : 'dias'}`;
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
    }).format(date);
  }

  map(alert: AlertNotification): NotificationModel {
    return {
      id: alert._id,
      title: alert.title,
      type: alert.type,
      description: alert.description,
      url: alert.url,
      openingDate: alert.isOpen ? new Date() : undefined,
      highlight: alert.highlight,
      userId: String(alert.idUsuario),
      createdAt: alert.createdAt,
    };
  }
}
